module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/point03-7f969e6853be77f95490f4bab5a5ef90.png";